import { getCache, putCache, queueRequest, flushQueue } from './offlineDb';
const BASE = import.meta.env.VITE_API_BASE || '/api/v1';
export class ApiError extends Error {
    status;
    constructor(status, message) {
        super(message);
        this.status = status;
    }
}
export function token() { return localStorage.getItem('casamb_token'); }
function headers(extra) {
    const result = new Headers(extra);
    result.set('Accept', 'application/json');
    if (token())
        result.set('Authorization', `Bearer ${token()}`);
    return result;
}
export async function api(path, options = {}) {
    const url = `${BASE}${path}`;
    const method = (options.method || 'GET').toUpperCase();
    const requestHeaders = headers(options.headers);
    if (options.body && !(options.body instanceof FormData))
        requestHeaders.set('Content-Type', 'application/json');
    try {
        const response = await fetch(url, { ...options, headers: requestHeaders });
        if (!response.ok) {
            const body = await response.json().catch(() => ({}));
            throw new ApiError(response.status, body.detail || `Errore HTTP ${response.status}`);
        }
        if (response.status === 204)
            return undefined;
        const data = await response.json();
        if (method === 'GET')
            await putCache(url, data);
        return data;
    }
    catch (error) {
        if (method === 'GET') {
            const cached = await getCache(url);
            if (cached !== null)
                return cached;
        }
        else if (!navigator.onLine) {
            const rawHeaders = {};
            requestHeaders.forEach((value, key) => rawHeaders[key] = value);
            await queueRequest({
                url, method, headers: rawHeaders,
                body: typeof options.body === 'string' ? options.body : undefined,
                createdAt: new Date().toISOString()
            });
            return { queued: true };
        }
        throw error;
    }
}
export async function syncOfflineQueue() {
    if (!navigator.onLine)
        return;
    await flushQueue(async (item) => {
        const response = await fetch(item.url, {
            method: item.method, headers: item.headers, body: item.body
        }).catch(() => null);
        return !!response?.ok;
    });
}
